import type { Command } from '../../types/commands'

export const themeCommand: Command = {
  name: 'theme',
  description: 'Toggle theme mode',
  usage: 'theme [professional|horror|tandy]',
  category: 'system',
  execute: (args) => {
    if (args.length === 0) {
      return [
        {
          type: 'info',
          content: `Current theme mode. Use 'theme professional', 'theme horror', or 'theme tandy' to switch.`,
        },
      ]
    }

    const mode = args[0].toLowerCase()

    if (mode !== 'professional' && mode !== 'horror' && mode !== 'tandy') {
      return [
        {
          type: 'error',
          content: `Invalid theme: ${mode}. Available themes: professional, horror, tandy`,
        },
      ]
    }

    // This will be handled by the Terminal component
    return [
      {
        type: 'info',
        content: `__THEME_${mode.toUpperCase()}__`,
      },
    ]
  },
}
